import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-115">
      <div className="max-w-6xl mx-auto" data-id="element-116">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-117">
          {/* For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 p-8 rounded-2xl border border-green-100" data-id="element-118">
            <h3 className="text-2xl font-bold text-brown mb-6 flex items-center gap-3" data-id="element-119">
              <span className="bg-green-100 p-2 rounded-full text-green-700" data-id="element-120">
                <Check className="w-5 h-5" data-id="element-121" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-122">
              <li className="flex items-start gap-3" data-id="element-123">
                <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-124" />
                <span className="text-brown-light" data-id="element-125">
                  Eres una mamá práctica que prefiere soluciones ("haz esto")
                  sobre teorías ("siente esto").
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-126">
                <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-127" />
                <span className="text-brown-light" data-id="element-128">
                  Amas a tu pareja, pero últimamente sientes que "no te
                  entiende" o que "todo es una lucha".
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-129">
                <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-130" />
                <span className="text-brown-light" data-id="element-131">
                  Tienes poco tiempo y cero paciencia para leer libros de 300
                  páginas ahora mismo.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-132">
                <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-133" />
                <span className="text-brown-light" data-id="element-134">
                  Estás dispuesta a probar algo diferente durante 7 días para
                  salvar la paz de tu hogar.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Not For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-135">
            <h3 className="text-2xl font-bold text-brown mb-6 flex items-center gap-3" data-id="element-136">
              <span className="bg-gray-200 p-2 rounded-full text-gray-600" data-id="element-137">
                <X className="w-5 h-5" data-id="element-138" />
              </span>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-139">
              <li className="flex items-start gap-3" data-id="element-140">
                <X className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-141" />
                <span className="text-brown-light" data-id="element-142">
                  Buscas terapia profunda para sanar traumas de la infancia
                  (esto es gestión de conflictos, no psicoanálisis).
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-143">
                <X className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-144" />
                <span className="text-brown-light" data-id="element-145">
                  Crees que el amor debería ser "fácil" y que usar un sistema le
                  quita el romanticismo.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-146">
                <X className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-147" />
                <span className="text-brown-light" data-id="element-148">
                  No estás dispuesta a invertir 10 minutos al día para mejorar
                  tu relación.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}